module.exports = __webpack_public_path__ + "img/8e97ab5.jpg";